import React from "react";
import { Box, Text, useTheme } from "@kolmeo/ui-core";
import { BankAccountDetails } from "@src/types/PaymentPreferences";
import { useTranslation } from "react-i18next";
import { useGlobalTenant } from "@src/navigation/hooks/useGlobalTenant";
import { OccupancyStatus } from "@src/types";
import { TooltipBranded } from "@src/components";
import { coreThemeV2 } from "@kolmeo/ui-components";

interface PaymentDetailsHeaderProps {
  paymentMethodLabel?: string;
  headlineFlag?: boolean;
  isInvoices?: boolean;
}

const PaymentDetailsHeader = ({ paymentMethodLabel, headlineFlag, isInvoices }: PaymentDetailsHeaderProps) => {
  const { spacing } = useTheme();
  const { t } = useTranslation(["Common", "Tenant"]);
  const { getSelectedTenancy } = useGlobalTenant();
  const { palette } = coreThemeV2;

  return (
    <Box paddingBottom={spacing.px16} zIndex={-1}>
      <Text fontWeight={600}>
        {isInvoices
          ? t("Tenant:PaymentMethods.InvoicePayment")
          : headlineFlag
          ? t("Tenant:PaymentMethods.RentandInvoicePayments")
          : t("Tenant:PaymentMethods.PaymentDetailsHeader")}
      </Text>

      <Box flexDirection={"row"} alignItems={"center"}>
        {isInvoices ? (
          <Text lineHeight={20} mt={spacing.px16}>
            {t("Tenant:PaymentMethods.InvoicePaymentInfo")}
          </Text>
        ) : (
          <>
            <Text lineHeight={20} color={palette.text.secondary}>
              {t("Tenant:PaymentMethods.RentPaymentMethod")}:{" "}
              <Text fontWeight={600} color={"#000"}>
                {paymentMethodLabel}
              </Text>
            </Text>
            {getSelectedTenancy?.status !== OccupancyStatus.inactive && (
              <Box style={{ marginLeft: 4, alignItems: "center" }}>
                <TooltipBranded content={t("Tenant:PaymentMethods.ChangePaymentMethodMessage")} position={"bottom"} />
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default PaymentDetailsHeader;
